import Handler from './handler'

/*!
 *
 * dummy handler (for debug)
 *
 */
export default class Console extends Handler {
  /*! prepare event function */
  __prepareEventFunction ({ name, data }) {
    return function () {
      return { name, data }
    }
  }

  /*! (real) send event */
  send (event) {
    /*! event arguments */
    const args = [
      event.name,
      event.data,
    ]

    this.debug('send:', args)
  }
}
